// src/components/tour-packages/forms/EditTourPackageForm.tsx

import {
  CreateTourPackageForm,
  type CreateTourPackageFormProps,
} from "./CreateTourPackageForm";

/**
 * For now, the edit form reuses the exact same UI as the create form.
 * The only difference is where/how you use it (on an Edit page with
 * pre-filled values and an update mutation).
 */
export type EditTourPackageFormProps = CreateTourPackageFormProps;

export function EditTourPackageForm(props: EditTourPackageFormProps) {
  return <CreateTourPackageForm {...props} />;
}
